import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Pasás horas armando planes y terminás agotado/a', 'En consulta te faltan estructura y foco', 'Cuando el paciente no avanza, no sabés qué ajustar primero', 'Explicás todo… pero igual no hay adherencia', 'Adaptar un plan te consume demasiado tiempo', 'El seguimiento termina siendo intuición e improvisación', 'Sabés que podrías cobrar mejor con un sistema más profesional'];
  return <section className="pt-4 pb-6 bg-surface relative z-10 border-b border-mint/10" data-id="element-175">
      <div className="max-w-4xl mx-auto px-4" data-id="element-176">
        <FadeIn data-id="element-177">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4 text-center text-mint" data-id="element-178">
            Si sos nutricionista, seguro alguna de estas te pega:
          </h2>
        </FadeIn>

        <div className="bg-red-950/30 border border-red-500/20 rounded-2xl p-4 mb-3" data-id="element-179">
          <div className="flex flex-col gap-2" data-id="element-180">
            {points.map((point, idx) => <FadeIn key={idx} delay={idx * 0.1} className="flex items-center gap-3 p-3 rounded-lg border border-red-500/10 bg-red-950/20" data-id="element-181">
                <XCircle className="text-red-400 shrink-0" size={20} data-id="element-182" />
                <p className="text-base font-medium text-dark/90" data-id="element-183">{point}</p>
              </FadeIn>)}
          </div>
        </div>

        <FadeIn delay={0.4} data-id="element-184">
          <p className="text-center text-2xl md:text-3xl italic max-w-2xl mx-auto font-[900] font-['Open_Sans',_sans-serif] text-dark/80 mt-6" data-id="element-185">
            ¿Cuántos domingos más vas a perder resolviendo en tu cabeza lo que
            podrías tener listo para usar?
          </p>
        </FadeIn>
      </div>
    </section>;
}